(() => {
  if(customElements.get('oc-quantity-breaks'))return;
  class QuantityBreaks extends HTMLElement {
    connectedCallback(){
      this.lifecycle?.abort();this.lifecycle=new AbortController();
      if(window.OCQBCore&&window.OCQBCart)this.init();
      else document.addEventListener('DOMContentLoaded',()=>this.init(),{once:true,signal:this.lifecycle.signal});
    }
    disconnectedCallback(){this.lifecycle?.abort();}
    init(){
      if(!this.isConnected)return;
      this.config=JSON.parse(this.querySelector('[data-qb-config]').textContent);
      this.button=this.querySelector('button[type="submit"]');this.message=this.querySelector('[data-message]');
      if(!window.OCQBCore||!window.OCQBCart){this.message.textContent=this.config.error;return;}
      this.formatter=new Intl.NumberFormat(this.config.locale||'fr',{style:'currency',currency:this.config.currency,currencyDisplay:this.config.currencyCode?'code':'symbol'});
      this.offers=this.config.offers.filter(o=>o.enabled);
      for(const offer of this.offers){
        const card=this.querySelector(`[data-offer="${offer.id}"]`);
        const container=card.querySelector('[data-variants]');container.replaceChildren();
        for(let n=0;n<offer.quantity;n++)container.append(this.selector(this.config.variants,this.config.options,n+1,'unit',this.config.selected));
        card._lastVariant=this.config.variants.find(v=>String(v.id)===container.querySelector('[data-unit]')?.value);
        if(this.config.singleVariant)container.hidden=true;
        if(offer.gift){
          const gifts=card.querySelector('[data-gift-options]');gifts.replaceChildren();
          for(let n=0;n<offer.giftQuantity;n++)gifts.append(this.selector(offer.giftVariants,offer.giftOptions,offer.quantity+n+1,'gift'));
        }
      }
      const selected=this.querySelector(`input[name="offer"][value="${this.config.defaultOffer}"]`)||this.querySelector('input[name="offer"]');
      if(selected)selected.checked=true;
      this.addEventListener('change',event=>this.onChange(event),{signal:this.lifecycle.signal});
      this.querySelector('form').addEventListener('submit',event=>{event.preventDefault();this.submit();},{signal:this.lifecycle.signal});
      this.update();
      if(this.button.disabled){const first=this.querySelector('input[name="offer"]:not(:disabled)');if(first){first.checked=true;this.update();}}
    }
    selector(variants,names,number,kind,selected){
      const wrapper=document.createElement('div');wrapper.className='oc-qb__option-row';
      wrapper._variants=variants;wrapper._kind=kind;
      const index=document.createElement('span');index.className='oc-qb__number';index.textContent='#'+number;index.setAttribute('aria-hidden','true');wrapper.append(index);
      const input=document.createElement('input');input.type='hidden';input.dataset[kind]='';wrapper.append(input);
      const initial=variants.find(v=>String(v.id)===String(selected)&&v.available)||variants.find(v=>v.available);
      const optionNames=names?.length?names:['Option'];
      optionNames.forEach((name,i)=>{
        const label=document.createElement('label');
        const accessible=document.createElement('span');accessible.className='oc-qb__sr-only';accessible.textContent=(kind==='gift'?this.config.giftLabel:this.config.unitLabel)+' '+number+' — '+name;label.append(accessible);
        const select=document.createElement('select');select.dataset.optionIndex=String(i);
        for(const value of new Set(variants.map(v=>this.values(v)[i]))){
          if(value==null)continue;
          const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option);
        }
        label.append(select);wrapper.append(label);
      });
      this.resolveRow(wrapper,initial||variants[0]);return wrapper;
    }
    values(variant){return variant.options?.length?variant.options:[variant.title];}
    resolveRow(row,variant){
      const selects=[...row.querySelectorAll('select')],values=variant?this.values(variant):[];
      selects.forEach((select,i)=>{
        for(const option of select.options)option.disabled=!row._variants.some(v=>v.available&&this.values(v)[i]===option.value&&values.slice(0,i).every((value,n)=>this.values(v)[n]===value));
        select.value=values[i]??'';
        select.disabled=!row._variants.some(v=>v.available);
      });
      row.querySelector('input').value=variant?.id??'';
    }
    onChange(event){
      const row=event.target.closest('.oc-qb__option-row'),card=event.target.closest('[data-offer]');
      if(row&&event.target.matches('select')){
        const values=[...row.querySelectorAll('select')].map(s=>s.value),index=Number(event.target.dataset.optionIndex);
        const matches=(v,length)=>values.slice(0,length).every((value,i)=>this.values(v)[i]===value);
        const variant=row._variants.find(v=>v.available&&matches(v,values.length))||row._variants.find(v=>v.available&&matches(v,index+1));
        this.resolveRow(row,variant);
        if(variant){
          if(row._kind==='unit'){card._lastVariant=variant;this.syncImage(card,variant,false);}
          else this.syncImage(card,variant,true);
        }
      }else if(event.target.matches('input[name="offer"]')&&card?._lastVariant){this.syncImage(card,card._lastVariant,false);}
      this.update();
    }
    syncImage(card,variant,gift){
      if(this.config.syncCard&&variant.image){
        const parent=card.querySelector(gift?'.oc-qb__gift':'.oc-qb__main');
        let img=parent?.querySelector(gift?'img':'.oc-qb__image');
        if(parent&&!img){img=document.createElement('img');img.alt='';img.loading='lazy';if(!gift)img.className='oc-qb__image';parent.insertBefore(img,gift?parent.firstChild:parent.querySelector('.oc-qb__copy'));}
        if(img){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=variant.image;}
      }
      const offer=this.offers.find(o=>String(o.id)===card.dataset.offer);
      if(this.config.syncGallery&&variant.mediaId&&(!gift||String(offer?.giftProductId)===String(this.config.productId)))this.syncGallery(variant.mediaId);
    }
    syncGallery(mediaId){
      // Dawn's setActiveMedia also scrolls the window. Update only gallery state
      // and horizontal sliders here; never focus, reorder slides or scroll the page.
      const scope=this.closest('product-info')||this.closest('.shopify-section')||document;
      const gallery=[...scope.querySelectorAll('media-gallery')].find(g=>g.id==='MediaGallery-'+this.config.sectionId)||scope.querySelector('media-gallery');
      if(!gallery)return;
      const id=this.config.sectionId+'-'+mediaId;
      const viewer=gallery.querySelector('[id^="GalleryViewer"]');
      const slides=[...(viewer||gallery).querySelectorAll('[data-media-id]')];
      const active=slides.find(slide=>slide.dataset.mediaId===id);if(!active)return;
      slides.forEach(slide=>slide.classList.toggle('is-active',slide===active));
      if(typeof window.pauseAllMedia==='function')window.pauseAllMedia();
      const slider=viewer?.slider||active.parentElement;
      slider.scrollTo({left:active.offsetLeft-slides[0].offsetLeft,top:slider.scrollTop,behavior:'instant'});
      const thumbnails=gallery.querySelector('[id^="GalleryThumbnails"]');
      thumbnails?.querySelectorAll('[data-target]').forEach(item=>{
        const button=item.querySelector('button');if(!button)return;
        if(item.dataset.target===id){button.setAttribute('aria-current','true');const strip=thumbnails.slider||item.parentElement;strip.scrollTo({left:item.offsetLeft,top:strip.scrollTop,behavior:'instant'});}
        else button.removeAttribute('aria-current');
      });
      viewer?.update?.();
    }
    getChoice(offer){
      const card=this.querySelector(`[data-offer="${offer.id}"]`);
      const ids=[...card.querySelectorAll('[data-unit]')].map(s=>s.value);
      const quote=OCQBCore.quote(offer,ids,this.config.variants);
      if(offer.gift){
        const giftIds=[...card.querySelectorAll('[data-gift]')].map(input=>input.value);
        quote.gifts=OCQBCore.aggregate(giftIds,offer.giftVariants);
        if(giftIds.length!==offer.giftQuantity)throw Error('Incomplete gift selection');
        quote.giftCompare=OCQBCore.money(offer.giftCompare)??quote.gifts.reduce((sum,item)=>sum+offer.giftVariants.find(v=>String(v.id)===String(item.id)).price*item.quantity,0);
      }
      return quote;
    }
    update(){
      const selected=this.querySelector('input[name="offer"]:checked')?.value;
      let valid=false,selectedTotal=null;
      for(const offer of this.offers){
        const card=this.querySelector(`[data-offer="${offer.id}"]`),radio=card.querySelector('input[name="offer"]');
        const current=String(offer.id)===selected;
        card.classList.toggle('is-selected',current);
        card.querySelector('[data-variants]').hidden=!current||this.config.singleVariant;
        if(offer.gift)card.querySelector('[data-gift-options]').hidden=!current||offer.giftVariants.length<=1;
        try{
          const quote=this.getChoice(offer);radio.disabled=false;card.classList.remove('is-unavailable');
          card.querySelector('[data-total]').textContent=this.formatter.format(quote.total/100);
          const compare=card.querySelector('[data-compare]');compare.textContent=this.formatter.format(quote.compare/100);compare.hidden=quote.compare<=quote.total;
          if(offer.gift)card.querySelector('[data-gift-compare]').textContent=this.formatter.format(quote.giftCompare/100);
          if(current){valid=true;selectedTotal=quote.total;}
        }catch{radio.disabled=true;card.classList.add('is-unavailable');card.querySelector('[data-total]').textContent='—';}
      }
      this.button.disabled=this.busy||(!valid&&!this.pendingRender);
      this.button.classList.toggle('is-loading',!!this.busy);
      this.button.setAttribute('aria-busy',String(!!this.busy));
      this.button.textContent=this.pendingRender?'Actualiser le panier':this.config.button+(this.config.showPrice&&selectedTotal!==null?' · '+this.formatter.format(selectedTotal/100):'');
      if(!valid&&!this.busy&&!this.pendingRender)this.message.textContent=this.config.error;
      else if(this.message.textContent===this.config.error)this.message.textContent='';
    }
    async submit(){
      if(this.busy||OCQBCart.busy||document.querySelector('.cart__items--disabled'))return;
      this.busy=true;this.message.textContent='';this.update();
      let drawer,error;
      try{
        await OCQBCart.serial(async()=>{
          drawer=OCQBCart.start(this.button);
          let state=this.pendingRender;
          if(state){state.sections=await OCQBCart.refresh();}
          else {
            const offer=this.offers.find(o=>String(o.id)===this.querySelector('input[name="offer"]:checked')?.value);
            if(!offer)throw new Error(this.config.error);
            const quote=this.getChoice(offer);
            const properties={_oc_qb:crypto.randomUUID(),_oc_qb_required:String(offer.quantity),_oc_qb_role:'paid'};
            const items=quote.items.map(i=>({...i,properties:{...properties}}));
            for(const gift of quote.gifts||[])items.push({...gift,properties:{...properties,_oc_qb_role:'gift'}});
            state=await OCQBCart.request('cart/add.js',{items,sections:OCQBCart.sectionIds,sections_url:window.location.pathname});
            this.pendingRender=state;
            try{OCQBCart.render(state.sections);}catch{state.sections=await OCQBCart.refresh();}
          }
          this.pendingRender=null;
          this.message.textContent='';
          if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'product-form',ocQB:true,cartData:state});
        });
      }catch(failure){
        error=this.pendingRender?'Les articles ont été ajoutés. Réessayez pour afficher le panier, sans les ajouter à nouveau.':(failure.message||this.config.error);
        this.message.textContent=error;
      }finally{this.busy=false;this.update();if(error)this.message.focus();}
    }
  }
  customElements.define('oc-quantity-breaks',QuantityBreaks);
})();
